export default "__VITE_ASSET__CTjQt4ZA__"